import React from 'react';
import cx from 'classnames';

import s from './Input.module.sass';

type InputProps = {
  theme?: keyof typeof themeClass
  address?: boolean
  className?: string
  placeholder: string
  error?: boolean
  active?: boolean
  value?: string
  name: string
} & React.InputHTMLAttributes<HTMLInputElement>;

const themeClass = {
  search: s.search,
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  address,
  className,
  placeholder,
  active,
  error,
  value,
  name,
  theme = 'search',
  ...props
}, ref) => {
  const compoundClassName = cx(
    s.root,
  );

  const compoundInputClassName = cx(
    s.input,
    themeClass[theme],
    { [s.pressed]: value },
    { [s.active]: active },
    { [s.error]: error },
    className,
  );

  return (
    <div className={compoundClassName}>
      <input
        id="input-search"
        type="text"
        ref={ref}
        className={compoundInputClassName}
        placeholder={placeholder}
        autoComplete="off"
        name={name}
        {...props}
      />
    </div>
  );
});

export default Input;
